import { imageStyles } from "@insite/content-library/Widgets/Basic/Image";
import { css } from "styled-components";

imageStyles.img = {
    css: css`
        width: 100%;
    `,
};
